import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "@/api/auth/auth.ts";
import { ChangeLogRecord } from "@/api/change-logs/change-logs";

interface UserState {
  currentUser: Partial<User>;
  permissions: {
    role: string;
    scopes: number;
  };
  tour: {
    stepIndex: number;
    run: boolean;
    isTourActive: boolean;
  };
  modals: {
    changeLog: {
      isOpen: boolean;
      records: ChangeLogRecord[];
    };
  };
}

const initialState: UserState = {
  currentUser: {
    first_name: "Not",
    last_name: "Loaded",
    middle_name: "Yet",
  },
  permissions: {
    role: "",
    scopes: 0,
  },
  tour: {
    stepIndex: 0,
    run: false,
    isTourActive: true,
  },
  modals: {
    changeLog: {
      isOpen: false,
      records: [],
    },
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.currentUser = action.payload;
    },
    setPermissionScopes(state, action: PayloadAction<number>) {
      state.permissions.scopes = action.payload;
    },
    setPermissionRole(state, action: PayloadAction<string>) {
      state.permissions.role = action.payload;
    },
    setTour(state, action: PayloadAction<Partial<UserState["tour"]>>) {
      state.tour = {
        ...state.tour,
        ...action.payload,
      };
    },
    setChangeLogModal(state, action: PayloadAction<boolean>) {
      state.modals.changeLog.isOpen = action.payload;
    },
    setChangeLogRecords(state, action: PayloadAction<ChangeLogRecord[]>) {
      state.modals.changeLog.records = action.payload;
    },
  },
});

export const {
  setUser,
  setPermissionScopes,
  setPermissionRole,
  setTour,
  setChangeLogModal,
  setChangeLogRecords,
} = userSlice.actions;

export default userSlice.reducer;
